const playawayHero = '/images/missing/playaway_hero.png';
const playawayCover = '/images/missing/playaway_cover.png';
const viewCover = '/images/missing/view_cover.png';
const bookpackHero = playawayHero;
const bookpackCover = playawayCover;
const launchpadHero = '/images/missing/launchpad_hero.png';
const launchpadCover = viewCover;

const serviceKit = '/images/missing/service_kit.png';
const warranty = '/images/missing/warranty.png';

const errorImages = {
    playaway: {
        hero: playawayHero,
        cover: playawayCover
    },
    'recorded-books': {
        hero: playawayHero,
        cover: playawayCover
    },
    bookpack: {
        hero: bookpackHero,
        cover: bookpackCover
    },
    bookpacks: {
        hero: bookpackHero,
        cover: bookpackCover
    },
    wonderbook: {
        hero: viewCover,
        cover: viewCover,
        inside: viewCover
    },
    launchpad: {
        hero: launchpadHero,
        cover: launchpadCover
    },
    'accessory-playaway': {
        hero: playawayCover,
        cover: playawayCover
    },
    'accessory-bookpack': {
        hero: playawayCover,
        cover: playawayCover
    },
    'accessory-launchpad': {
        hero: viewCover,
        cover: viewCover
    },
    'service-playaway': {
        hero: serviceKit,
        cover: serviceKit
    },
    'service-launchpad': {
        hero: serviceKit,
        cover: serviceKit
    },
    'service-bookpack': {
        hero: serviceKit,
        cover: serviceKit
    },
    'service-wonderbook': {
        hero: serviceKit,
        cover: serviceKit
    },
    'warranty-launchpad': {
        hero: warranty,
        cover: warranty
    }
};
export default errorImages;
